module.exports = __webpack_public_path__ + "img/16_75.6f7f012d.png";